import { createCsvValidator } from '~/components/general/createCsvValidator';

const GROUP_FIELDS = ['group_id', 'group_role'];

export const usersCsvValidator = createCsvValidator({
    maxFileSizeBytes: 100 * 1000 ** 2,
    requiredHeadings: ['name', 'email'],
    optionalHeadings: ['team_role', ...GROUP_FIELDS],
    validateHeadings: (headings: string[]) => {
        const hasAnyGroupField = GROUP_FIELDS.some((field) => headings.includes(field));
        if (hasAnyGroupField) {
            const hasAllGroupFields = GROUP_FIELDS.every((field) => headings.includes(field));
            if (!hasAllGroupFields) {
                return 'Headings group_id and group_role are required if any of them have been set.';
            }
        }
        return undefined;
    },
});

export const validateUsersCsv = usersCsvValidator.validate;
